export default __webpack_public_path__ + "static/media/pvn-livro.3352af9b.webp";